import { Shield, Loader2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { EditUserDialog } from "./edit-user-dialog";
import { DeleteUserDialog } from "./delete-user-dialog";
import type { UserWithProfile } from "@/pages/Users";

interface UsersTableProps {
  users: UserWithProfile[];
  isLoading: boolean;
  onUserUpdated: () => Promise<void>;
}

export function UsersTable({ users, isLoading, onUserUpdated }: UsersTableProps) {
  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    try {
      return new Date(dateString).toLocaleDateString("fr-FR");
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Date invalide";
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Nom</TableHead>
          <TableHead>Email</TableHead>
          <TableHead>Date de création</TableHead>
          <TableHead>Rôle</TableHead>
          <TableHead className="w-[100px]">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {users.map((user) => (
          <TableRow key={user.id}>
            <TableCell>
              {user.profiles?.first_name} {user.profiles?.last_name}
            </TableCell>
            <TableCell>{user.profiles?.email}</TableCell>
            <TableCell>{formatDate(user.created_at)}</TableCell>
            <TableCell>
              <div className="flex items-center gap-1">
                <Shield className="h-4 w-4 text-muted-foreground" />
                <span className="capitalize">
                  {user.user_roles[0]?.role ?? "user"}
                </span>
              </div>
            </TableCell>
            <TableCell>
              <div className="flex items-center gap-2">
                <EditUserDialog user={user} onUserUpdated={onUserUpdated} />
                <DeleteUserDialog 
                  userId={user.id}
                  userName={`${user.profiles?.first_name} ${user.profiles?.last_name}`.trim()}
                  onUserDeleted={onUserUpdated}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}